/**
 * Display-only photo tile for SelectPhotosPanel : just the thumbnail, no drag, no delete, no
 * selection. Kept apart from PhotoRenderer (editor tile) and SharedPhotoSelectRenderer (selectable).
 */
fx.ns("shared.renderers", class ReceivedPhotoRenderer extends fx.Component {

	create()
	{
		// display only : the grid derives tile ratios from the photo model, so no drag/size data-* here
		this.image = new fx.components.Image({ className : "photo", data : this.data.thumb });
		this.image.attr("data-id", this.data.id);

		this.addChild(this.image);
	}

	onDataUpdated(action)
	{
		if (!this.initialized || !this.image || !this.data)
			return;

		if (this.data.deleted)
		{
			this.hide();
			return;
		}

		if (this.data.thumb)
			this.image.src = this.data.thumb;
	}
});
